export default __webpack_public_path__ + "static/media/app_logo_sonoa.81247121.png";